import ScalarComboboxMultiselect_vue_vue_type_script_setup_true_lang_default from "./ScalarComboboxMultiselect.vue.script.js";
//#region src/components/ScalarCombobox/ScalarComboboxMultiselect.vue
var ScalarComboboxMultiselect_default = ScalarComboboxMultiselect_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarComboboxMultiselect_default as default };

//# sourceMappingURL=ScalarComboboxMultiselect.vue.js.map